import React, { useState, useEffect, useRef, useMemo } from "react";
import { goExternal } from "../../utils/shoplineEmbedded";
import Blogs_Section from "./blogs_section";
import Episodes_Section from "./episodes_section";
import Clips_Section from "./clips_section";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Select,
  Modal,
  Box,
  Stack,
  Tooltip,
  Typography,
  IconButton,
  Divider,
  Slider,
  InputAdornment,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import sample_setting_img from "../../assets/img/card-img-3.png";
import { LoadingButton } from "@mui/lab";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Ocesha_new_des_logo from "../../assets/ocesha_images/ocesha_new_des_logo.png";
import "./ocesha.css";
import { ReactComponent as BlogsIco } from "../../assets/ocesha_images/blogs_ico.svg";
import { ReactComponent as VideoIco } from "../../assets/ocesha_images/video_ico.svg";
import { ReactComponent as AudioIco } from "../../assets/ocesha_images/audio_ico.svg";
import { ReactComponent as ImagesIco } from "../../assets/ocesha_images/images_ico.svg";
import { ReactComponent as ClipIco } from "../../assets/ocesha_images/clip_ico.svg";
import { ReactComponent as EpisodeIco } from "../../assets/ocesha_images/episode_ico.svg";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Team menu is commented out for now
import { ReactComponent as TeamIco } from "../../assets/ocesha_images/team_ico.svg";
import { ReactComponent as IntegrationIco } from "../../assets/ocesha_images/integration_ico.svg";
import { ReactComponent as UpgradeIco } from "../../assets/ocesha_images/upgrade_ico.svg";
import { ReactComponent as BillingIco } from "../../assets/ocesha_images/billing_ico.svg";
import { ReactComponent as SettingsIco } from "../../assets/ocesha_images/settings_ico.svg";
import { ReactComponent as HelpIco } from "../../assets/ocesha_images/help_ico.svg";
import { ReactComponent as LogoutIco } from "../../assets/ocesha_images/logout_ico.svg";
import { ReactComponent as DashboardIco } from "../../assets/ocesha_images/dashboard_ico.svg";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import OceshaDashboard from "./ocesha_dashboard";
import MyDashboard from "pages/traffic_monster/campaigns/courses_dashboard";
import Image_listing from "./image_listing";
import { isMobile } from "react-device-detect";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useGetUserDetailsMutation } from "../../redux/api/authApi";
import {
  usePublishUnpublishCountMutation,
  useCampaignListMutation,
  useGetGeneratedEpisodeListingsMutation,
  useGetGeneratedImageListingsMutation,
} from "../../redux/api/promptApi";
import {
  usePlanDetailsMutation,
  useLazyGetProductQuery,
} from "../../redux/api/productApi";
import { useAppSelector } from "../../redux/store";
import { IPlanDetail } from "../../redux/api/types";
import { useLazyCreateCheckoutSessionQuery } from "../../redux/api/subscriptionApi";
import { getCookie } from "utils/storageUtils";
import { useNavigate, useLocation } from "react-router-dom";
import Usersetting from "pages/Usersetting";
import { logout } from "../../redux/features/userSlice";
import { useAppDispatch } from "../../redux/store";
import { removeCookie } from "utils/storageUtils";
import { toast } from "react-toastify";
import ocesha_logo from "../../assets/ocesha_images/ocesha_logo.png";
import Billing from "./billing";
import DigitalTwinScreen from "../traffic_monster/campaigns/Mydigitaltwinscreen";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import youtubeIco1 from "../../assets/traffic_monster/youtubeIco_1.png";
import InfoIcon from "@mui/icons-material/Info";
import PersonIcon from "@mui/icons-material/Person";
import AddPayment from "pages/traffic_monster/campaigns/payment";
import ConnectShopline from "pages/traffic_monster/campaigns/ConnectShopline";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import FolderIcon from "@mui/icons-material/Folder";
import InsightsIcon from "@mui/icons-material/Insights";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ListingCourses from "pages/traffic_monster/campaigns/listing-courses";
import PricingPage from "pages/pricing.page";
import AuthorityEngine from "pages/traffic_monster/campaigns/authorityEngine";
import New_Course_2_1 from "pages/traffic_monster/campaigns/new_course_2_1";
import Marketing from "pages/traffic_monster/campaigns/marketing";
import SendIcon from "@mui/icons-material/Send";
import SocialPost from "pages/traffic_monster/campaigns/socialPost";
import New_Course_3 from "pages/traffic_monster/campaigns/new_course_3";
import CampaignIcon from "@mui/icons-material/Campaign";
import MessagesAndFollowers from "pages/traffic_monster/campaigns/message";
import { Person2Outlined } from "@mui/icons-material";
import New_Campaign from "pages/traffic_monster/campaigns/new_campaign";
import New_Podcast from "pages/traffic_monster/campaigns/new_podcast";
import InstructorProfilePage from "pages/traffic_monster/campaigns/instructor_profile_page";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AnalyticsDashboard from "pages/traffic_monster/campaigns/analytics";
import latestDashBoardVideo from '../../assets/traffic_monster/latest_dashboard_video.mp4';

// ── NEW: imports for the redesigned sidebar + header ────────────────
import YouTubeIcon from "@mui/icons-material/YouTube";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import BoltIcon from "@mui/icons-material/Bolt";
import RohanImg from "../../assets/podcast_monster/rohan_png.png";
import UserImg from "../../assets/podcast_monster/user_img.png";
import AIConciergePopup from "../../components/AIConciergePopup";
import ContactUsModal from "../../components/ContactUsModal";
import GBA_Registration from "pages/auth/GBA_Registration";
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import GBALogo from '../../assets/traffic_monster/GBA_Logo.png';
import axios from "axios";
import LanguageSwitcher from "components/LanguageSwitcher";
import TeamMembersModal from "./TeamMembersModal";
import { redirectAfterLogout } from "../../utils/logoutRedirect";
import CourseEnrollments from "../../components/CourseEnrollments";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

const params = new URLSearchParams(window.location.search);
const return_domain = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

// ── Lumi (Ocesha AI Concierge widget) ──
// Equivalent to:
// <script src="https://ocesha.com/ci/v1/loader.js" data-ocesha-ci-key="ci_pk_a18080ffa7084aa031ba1a59ca4cebb8" async></script>
const OCESHA_CI_SRC = "https://lovelumi.ai/ci/v1/loader.js";
const OCESHA_CI_KEY = "ci_pk_b428a760499c65890d0928d859ead250";

type PlanTier = "FREE" | "STARTER" | "GROWTH" | "PRO";

const SUBSCRIPTION_LEVEL_TO_PLAN_TIER: Record<string, PlanTier> = {
  level_0a: "FREE",
  level_4: "STARTER",
  level_5: "STARTER",
  level_0: "GROWTH",
  level_2: "GROWTH",
  level_1: "PRO",
  level_3: "PRO",
};

// Add-on credit purchases are only offered on these tiers.
const ADD_ON_ELIGIBLE_TIERS: PlanTier[] = ["GROWTH", "PRO"];

// Team members feature — highest plan only ($199)
const TEAM_ELIGIBLE_TIERS: PlanTier[] = ["PRO"];


const Ocesha_new_design = () => {
  const role = localStorage.getItem("userRole");
  const defaultItem = role === "student" ? "course" : "dashboard";

  const [activeItem, setActiveItem] = useState(
    params.get("activeItem") ||
    localStorage.getItem("activeItem") ||
    "authority",
  );
  const [podcostId, setPodCostId] = useState(
    params.get("podcostId") || localStorage.getItem("podcostId") || "",
  );

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [contactUsOpen, setContactUsOpen] = useState(false);
  // "Contact Us" clicked in another page's menu (e.g. the publish page)
  useEffect(() => {
    try {
      if (localStorage.getItem("openContactUs") === "1") {
        localStorage.removeItem("openContactUs");
        setContactUsOpen(true);
      }
    } catch { /* ignore */ }
  }, []);

  const [isDigitalTwinUploading, setIsDigitalTwinUploading] = useState(false);

  const [leaveUploadConfirmOpen, setLeaveUploadConfirmOpen] = useState(false);
  const [pendingMenuItem, setPendingMenuItem] = useState<any>(null);
  const uploadAbortRef = useRef<(() => void) | undefined>(undefined);

  const [GBAUserLogo, setGBAUserLogo] = useState<any>();


  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { FromCampaign } = location.state || {};
  const { userEmail } = location.state || {};
  const { FromUpdatedCampaign } = location.state || {};
  const [isContentOpen, setIsContentOpen] = useState(true);

  const [userDets, setUserDets] = useState<any>();
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [publishedUnpublishedCount, setPublishedUnpublishedCount] =
    useState<any>();
  const [planDetails, setPlanDetails] = useState<any>();
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [campaignListDatas, setCampaignListDatas] = useState<any>();
  const [episodeListDatas, setEpisodeListDatas] = useState<any>();
  const [imageListDatas, setImageListDatas] = useState<any>();

  const [helpervideosrc, setHelperVideoSrc] = useState<any>();
  const [helperPopup, setHelperPopup] = useState<boolean>(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
  const isProfileMenuOpen = Boolean(profileMenuAnchor);

  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [publishUnpublishCountMutation] = usePublishUnpublishCountMutation();
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const [createAddOnCheckoutSession, addOnCheckoutState] = useLazyCreateCheckoutSessionQuery();
  const genieSelector = useAppSelector((state) => state.genieState);
  const [getProduct, getProductState] = useLazyGetProductQuery();
  const [campaignListMutation] = useCampaignListMutation();
  const [getGeneratedEpisodeListingsMutation] =
    useGetGeneratedEpisodeListingsMutation();
  const [getGeneratedImageListingsMutation] =
    useGetGeneratedImageListingsMutation();
  const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
  const [addCreditsOpen, setAddCreditsOpen] = useState<boolean>(false);
  const [purchasingCredits, setPurchasingCredits] = useState<boolean>(false);

  const MIN_ADDON_AMOUNT = 1;
  const MAX_ADDON_AMOUNT = 1000;
  const ADDON_QUICK_AMOUNTS = [10, 25, 50, 100, 250, 500];

  const [addOnAmount, setAddOnAmount] = useState<number>(50);
  // Raw text field value, so the user can freely type/clear digits before
  // we clamp on blur — avoids fighting the cursor on every keystroke.
  const [addOnAmountInput, setAddOnAmountInput] = useState<string>("50");

  const clampAddOnAmount = (value: number) =>
    Math.min(MAX_ADDON_AMOUNT, Math.max(MIN_ADDON_AMOUNT, value));

  const subscriptionLevel =
    planDetails?.subscription_level || localStorage.getItem("subscription_level") || "";
  const currentPlanTier = SUBSCRIPTION_LEVEL_TO_PLAN_TIER[subscriptionLevel];
  const canAddOnCredits = ADD_ON_ELIGIBLE_TIERS.includes(currentPlanTier);

  const [teamModalOpen, setTeamModalOpen] = useState<boolean>(false);
  const canUseTeam = TEAM_ELIGIBLE_TIERS.includes(currentPlanTier);

  const handlePurchaseCredits = () => {
    const amount = clampAddOnAmount(addOnAmount);
    setPurchasingCredits(true);
    createAddOnCheckoutSession({
      emailid: useremail || "",
      username: useremail || "",
      subscription_level: subscriptionLevel || "",
      referral_param: "",
      couponcode: "",
      mode: "",
      campaignid: "",
      from_page: "dashboard_addon",
      return_domain,
      type: "addon",
      unit_amount: String(amount),
    });
  };

  // Same redirect pattern as the pricing/upgrade page: once the checkout
  // session comes back, send the user to Stripe's hosted checkout_url.
  useEffect(() => {
    if (addOnCheckoutState.isSuccess) {
      if (addOnCheckoutState.data?.checkout_url) {
        goExternal(addOnCheckoutState.data.checkout_url);   // popup when inside SHOPLINE
      } else {
        setPurchasingCredits(false);
        toast.error("Couldn't start checkout. Please try again.");
      }
    } else if (addOnCheckoutState.isError) {
      setPurchasingCredits(false);
      toast.error("Couldn't start checkout. Please try again.");
    }
  }, [addOnCheckoutState]);

  const useremail = localStorage.getItem("user_email") || "";

  const [searchstr, setSearchstr] = useState<any>();
  const [openAIConcierge, setOpenAIConcierge] = useState(false);
  const COURSE_IDS: Record<string, string> = {
    authority: "6a155067b7d74efa94037f49",
    course: "6a155245b7d74efa94037f4a",
    blogs: "6a1552dfb7d74efa94037f4b",
    episodes: "6a1553b6b7d74efa94037f4c",
    clips: "6a15544db7d74efa94037f4d",
    images: "6a1554e3b7d74efa94037f4e",
    socailpost: "6a15556db7d74efa94037f4f",
  };
  const currentCourseId = COURSE_IDS[activeItem] || "";

  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: useremail || getCookie("user_email") || "",
        filter: "",
        start_date: "",
        end_date: "",
      });
      if ("data" in response) {
        setUserDets(response.data.data);
        console.log(response.data.data);
      }
    } catch (error) { }
  };

  const expired = localStorage.getItem("expired");

  const hasValidExpiry = expired === "false"; //returns true if not expired


  /* useEffect(() => {
    fetchData();
  }, []); */
  useEffect(() => {
    fetchData();

    const handleProfileUpdated = () => {
      fetchData();
      setImageVersion(Date.now());
    };

    // Any part of the app that consumes/awards credits (generating a blog,
    // course, post, buying an add-on, etc.) can dispatch this event to make
    // the header's credit count refetch immediately, e.g.:
    //   window.dispatchEvent(new CustomEvent("creditsUpdated"));
    const handleCreditsUpdated = () => {
      fetchData();
    };

    window.addEventListener("profileUpdated", handleProfileUpdated);
    window.addEventListener("creditsUpdated", handleCreditsUpdated);

    return () => {
      window.removeEventListener(
        "profileUpdated",
        handleProfileUpdated
      );
      window.removeEventListener("creditsUpdated", handleCreditsUpdated);
    };
  }, []);

  useEffect(() => {
    const p = params.get("activeItem");
    if (p) setActiveItem(p);
  }, [params]);

  useEffect(() => {
    const handler = (e: any) => {
      setGBAUserLogo(e.detail.logo);
    };

    window.addEventListener("partner-logo-updated", handler);

    return () => {
      window.removeEventListener("partner-logo-updated", handler);
    };
  }, []);

  const fetchingPublishDatas = async (campaignId: string) => {
    try {
      const responseCount = await publishUnpublishCountMutation({
        email: useremail || getCookie("user_email") || "",
        campaignid: campaignId,
      });
      if ("data" in responseCount) {
        const datas = responseCount.data;
        setPublishedUnpublishedCount(datas);
      }
    } catch (error) {
      console.log("Error fetching publishing counts data:", error);
    }
  };

  useEffect(() => {
    fetchingPublishDatas("");
  }, []);

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({
        email: useremail,
        campaignid: "",
      });
      if ("data" in response) {
        setPlanDetails(response.data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchPlanDatas();
  }, []);

  const [plans, setPlans] = useState<IPlanDetail[]>([
    {
      user: 1, plan_name: "", total_wishes: 0, price: "", period: "",
      product_id: "", price_id: "", subscription_level: "",
      feature: [], contracts: 0, type: "", button_text: "", save: "",
    },
  ]);

  useEffect(() => {
    const { data } = getProductState;
    if (data?.plan_details) {
      setPlans([...data?.plan_details]);
    } else
      setPlans([
        {
          user: 1, plan_name: "", total_wishes: 0, price: "", period: "",
          product_id: "", price_id: "", subscription_level: "",
          feature: [], contracts: 0, type: "", button_text: "", save: "",
        },
      ]);
  }, [getProductState]);

  const campaignRes = async () => {
    try {
      const response = await campaignListMutation({ email: useremail || "" });
      if ("data" in response) {
        setCampaignListDatas(response.data);
      }
    } catch (error) { }
  };

  const episodeListsRes = async () => {
    try {
      const response = await getGeneratedEpisodeListingsMutation({
        email: useremail || "", limitval: 12, skipval: 0,
        search: searchstr || "",
      });
      if ("data" in response) {
        setEpisodeListDatas(response.data);
      }
    } catch (error) { }
  };

  const imageListsRes = async () => {
    try {
      const podcostId = localStorage.getItem("podcastId");
      const response = await getGeneratedImageListingsMutation({
        email: useremail || "", product_id: podcostId || "",
        limitval: 12, skipval: 0,
      });
      if ("data" in response) {
        setImageListDatas(response.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    const publishingblogCampId = localStorage.getItem("publishingCampId");
    if (publishingblogCampId) {
      setSelectedCampaign(publishingblogCampId);
      fetchingPublishDatas(publishingblogCampId);
    } else if (FromCampaign) {
      setSelectedCampaign(FromCampaign);
      fetchingPublishDatas(FromCampaign);
      localStorage.setItem("campId", FromCampaign);
      const count = 0;
      localStorage.setItem("refreshCount", count.toString());
      const refreshPage = () => {
        const refreshCountStr = localStorage.getItem("refreshCount");
        const refreshCountt =
          refreshCountStr !== null ? parseInt(refreshCountStr) : 0;
        if (refreshCountt < 1) {
          setTimeout(() => {
            localStorage.setItem("refreshCount", (refreshCountt + 1).toString());
            setSelectedCampaign(FromCampaign);
            fetchingPublishDatas(FromCampaign);
          }, 20000);
        }
      };
      refreshPage();
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, FromCampaign: null },
      });
    } else if (FromUpdatedCampaign) {
      setSelectedCampaign(FromUpdatedCampaign);
      fetchingPublishDatas(FromUpdatedCampaign);
      localStorage.setItem("campId", FromUpdatedCampaign);
    } else if (campaignListDatas && campaignListDatas.length > 0) {
      const savedCampId = localStorage.getItem("campId");
      if (!savedCampId) {
        setSelectedCampaign(campaignListDatas[0].campaign_id);
        fetchingPublishDatas(campaignListDatas[0].campaign_id);
        localStorage.setItem("campId", campaignListDatas[0].campaign_id);
      } else {
        setSelectedCampaign(savedCampId);
        fetchingPublishDatas(savedCampId);
      }
    }
  }, [campaignListDatas, FromCampaign, FromUpdatedCampaign, location, navigate]);

  useEffect(() => { campaignRes(); }, []);
  useEffect(() => { episodeListsRes(); }, []);

  const clearCookies = () => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name] = cookie.split("=");
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
    }
  };

  const handleItemClick = (itemName: any) => {

    /* if (isDigitalTwinUploading && activeItem === "digital" && itemName !== "digital") {
      const okToLeave = window.confirm(
        "An upload is still in progress. If you leave this page now, the upload will stop and you'll need to upload it again.\n\nDo you want to leave anyway?"
      );
      if (!okToLeave) {
        return; // stay put, don't switch menus
      }
      // User chose to leave on purpose — clear the flag so we don't ask again.
      setIsDigitalTwinUploading(false);
    } */

    if (isDigitalTwinUploading && activeItem === "digital" && itemName !== "digital") {
      setPendingMenuItem(itemName);
      setLeaveUploadConfirmOpen(true);
      return;
    }

    localStorage.setItem("activeItem", itemName);
    localStorage.removeItem("podcastId");
    setActiveItem(
      localStorage.getItem("activeItem")
        ? localStorage.getItem("activeItem")
        : itemName,
    );
    localStorage.removeItem("campaignid");
    localStorage.removeItem("returningtocampaign");
    localStorage.removeItem("sourceurl");
    localStorage.removeItem("campaignName");
    localStorage.removeItem("paymentOption");
    localStorage.removeItem("autoPublish");
    localStorage.removeItem("limitPublish");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("addTags");
    localStorage.removeItem("captureLeads");
    localStorage.removeItem("newsLetter");
    localStorage.removeItem("twitterBtn");
    localStorage.removeItem("fbBtn");
    localStorage.removeItem("pintrestBtn");
    localStorage.removeItem("linkedinBtn");
    localStorage.removeItem("video");
    localStorage.removeItem("twitterurl");
    localStorage.removeItem("fburl");
    localStorage.removeItem("pintresturl");
    localStorage.removeItem("linkedinurl");
    localStorage.removeItem("smUrlpublish");
    localStorage.removeItem("owndomain");
    localStorage.removeItem("ChangepayMode");
    localStorage.removeItem("IdChangingMode");
    localStorage.removeItem("PaymentSubscription");
    localStorage.removeItem("Authorurl");
    localStorage.removeItem("Authorname");
    localStorage.removeItem("authorDefaultCheck");
    localStorage.removeItem("videoTag");
    localStorage.removeItem("podcastUrl");
    localStorage.removeItem("sourcetext");

    if (itemName === "upgrade" || (!hasValidExpiry && itemName !== "logout" && itemName !== "settings")) {
      localStorage.setItem("fromUpgrade", "true");
      setActiveItem("upgrade");
    } else if (itemName === "logout") {
      clearCookies();
      localStorage.setItem("logged_in", "false");
      dispatch(logout());
      var module = localStorage.getItem("module");
      toast.success("Logout success");
      localStorage.removeItem("msg");
      localStorage.removeItem("complexity");
      localStorage.removeItem("module");
      localStorage.removeItem("subscription_level");
      localStorage.removeItem("free_plan");
      localStorage.removeItem("localStorage_msg");
      localStorage.removeItem("allSet");
      localStorage.removeItem("Blogs Generated");
      localStorage.removeItem("remaining_wish_count");
      localStorage.removeItem("userRole");
      localStorage.removeItem("payment");
      localStorage.removeItem("user_email");
      localStorage.removeItem("logged_in");
      localStorage.removeItem("prevImg");
      localStorage.removeItem("fromUpgrade");
      localStorage.removeItem("blogsCount");
      localStorage.removeItem("Generating Count");
      localStorage.removeItem("finalData");
      localStorage.removeItem("user_pass");
      localStorage.removeItem("fromNewcampaign");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("campId");
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("smUrlpublish");
      localStorage.removeItem("addTags");
      localStorage.removeItem("captureLeads");
      localStorage.removeItem("newsLetter");
      localStorage.removeItem("twitterBtn");
      localStorage.removeItem("fbBtn");
      localStorage.removeItem("pintrestBtn");
      localStorage.removeItem("linkedinBtn");
      localStorage.removeItem("video");
      localStorage.removeItem("twitterurl");
      localStorage.removeItem("fburl");
      localStorage.removeItem("pintresturl");
      localStorage.removeItem("linkedinurl");
      localStorage.removeItem("owndomain");
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      localStorage.removeItem("user_name");
      localStorage.removeItem("refreshCount");
      localStorage.removeItem("publishingCampId");
      localStorage.removeItem("Authorurl");
      localStorage.removeItem("Authorname");
      localStorage.removeItem("authorDefaultCheck");
      localStorage.removeItem("appsumo_coupon_code");
      localStorage.removeItem("podcastUrl");
      localStorage.removeItem("AlertMessage");
      localStorage.removeItem("CreatingfromLanding");
      localStorage.removeItem("UrlfromLanding");
      localStorage.removeItem("signedup");
      localStorage.removeItem("uploadedvideo");
      localStorage.removeItem("uploadedVideoName");
      localStorage.removeItem("uploadStatus");
      localStorage.removeItem("editedposthashtags");
      localStorage.removeItem("editedpostblogsummary");
      localStorage.removeItem("editedpostblogtitle");
      localStorage.removeItem("editedposturl");
      localStorage.removeItem("user_email");
      localStorage.removeItem("YoutubeUrlfromLanding");
      localStorage.removeItem("FirstLogin");
      localStorage.removeItem("DirectSignup");
      localStorage.removeItem("FromIndexPage");
      localStorage.removeItem("activeItem");
      localStorage.removeItem("UpdateduserImage");
      localStorage.removeItem("FromEditBlog");
      localStorage.removeItem("ErrorAlert");
      localStorage.removeItem("FromSignIn");
      removeCookie("user_email");
      localStorage.clear();
      if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
        navigate("/Anycode_landing");
      else redirectAfterLogout(); //"https://ocesha.ai";
    } else if (itemName == "images") {
      setActiveItem("images");
    } else if (itemName == "createcourse") {
      setActiveItem("createcourse");
    } else if (itemName === "course") {
      setActiveItem("course");
    } else if (itemName === "profile" || itemName === "authority") {
      navigate(location.pathname, {
        replace: true,
        state: { creator: userDets },
      });

    } else if (itemName === "digital") {
      setActiveItem("digital");
    } else if (itemName === "createcourse3") {
      setActiveItem("createcourse3");
    }
  };

  const handleConfirmLeaveUpload = () => {
    setLeaveUploadConfirmOpen(false);
    uploadAbortRef.current?.();
    setIsDigitalTwinUploading(false);
    const itemName = pendingMenuItem;
    setPendingMenuItem(null);
    if (itemName === "__browser_back__") {
      window.history.go(-2);
      return;
    }

    if (itemName) {
      // proceedWithItemClick(itemName);
      localStorage.setItem("activeItem", itemName);
      localStorage.removeItem("podcastId");
      setActiveItem(
        localStorage.getItem("activeItem")
          ? localStorage.getItem("activeItem")
          : itemName,
      );
      localStorage.removeItem("campaignid");
      localStorage.removeItem("returningtocampaign");
      localStorage.removeItem("sourceurl");
      localStorage.removeItem("campaignName");
      localStorage.removeItem("paymentOption");
      localStorage.removeItem("autoPublish");
      localStorage.removeItem("limitPublish");
      localStorage.removeItem("smUrlpublish");
      localStorage.removeItem("addTags");
      localStorage.removeItem("captureLeads");
      localStorage.removeItem("newsLetter");
      localStorage.removeItem("twitterBtn");
      localStorage.removeItem("fbBtn");
      localStorage.removeItem("pintrestBtn");
      localStorage.removeItem("linkedinBtn");
      localStorage.removeItem("video");
      localStorage.removeItem("twitterurl");
      localStorage.removeItem("fburl");
      localStorage.removeItem("pintresturl");
      localStorage.removeItem("linkedinurl");
      localStorage.removeItem("smUrlpublish");
      localStorage.removeItem("owndomain");
      localStorage.removeItem("ChangepayMode");
      localStorage.removeItem("IdChangingMode");
      localStorage.removeItem("PaymentSubscription");
      localStorage.removeItem("Authorurl");
      localStorage.removeItem("Authorname");
      localStorage.removeItem("authorDefaultCheck");
      localStorage.removeItem("videoTag");
      localStorage.removeItem("podcastUrl");
      localStorage.removeItem("sourcetext");

      if (itemName === "upgrade" || (!hasValidExpiry && itemName !== "logout" && itemName !== "settings")) {
        localStorage.setItem("fromUpgrade", "true");
        setActiveItem("upgrade");
      } else if (itemName === "logout") {
        clearCookies();
        localStorage.setItem("logged_in", "false");
        dispatch(logout());
        var module = localStorage.getItem("module");
        toast.success("Logout success");
        localStorage.removeItem("msg");
        localStorage.removeItem("complexity");
        localStorage.removeItem("module");
        localStorage.removeItem("subscription_level");
        localStorage.removeItem("free_plan");
        localStorage.removeItem("localStorage_msg");
        localStorage.removeItem("allSet");
        localStorage.removeItem("Blogs Generated");
        localStorage.removeItem("remaining_wish_count");
        localStorage.removeItem("userRole");
        localStorage.removeItem("payment");
        localStorage.removeItem("user_email");
        localStorage.removeItem("logged_in");
        localStorage.removeItem("prevImg");
        localStorage.removeItem("fromUpgrade");
        localStorage.removeItem("blogsCount");
        localStorage.removeItem("Generating Count");
        localStorage.removeItem("finalData");
        localStorage.removeItem("user_pass");
        localStorage.removeItem("fromNewcampaign");
        localStorage.removeItem("campaignid");
        localStorage.removeItem("returningtocampaign");
        localStorage.removeItem("sourceurl");
        localStorage.removeItem("campaignName");
        localStorage.removeItem("paymentOption");
        localStorage.removeItem("autoPublish");
        localStorage.removeItem("limitPublish");
        localStorage.removeItem("campId");
        localStorage.removeItem("campaignid");
        localStorage.removeItem("returningtocampaign");
        localStorage.removeItem("sourceurl");
        localStorage.removeItem("campaignName");
        localStorage.removeItem("paymentOption");
        localStorage.removeItem("autoPublish");
        localStorage.removeItem("limitPublish");
        localStorage.removeItem("smUrlpublish");
        localStorage.removeItem("addTags");
        localStorage.removeItem("captureLeads");
        localStorage.removeItem("newsLetter");
        localStorage.removeItem("twitterBtn");
        localStorage.removeItem("fbBtn");
        localStorage.removeItem("pintrestBtn");
        localStorage.removeItem("linkedinBtn");
        localStorage.removeItem("video");
        localStorage.removeItem("twitterurl");
        localStorage.removeItem("fburl");
        localStorage.removeItem("pintresturl");
        localStorage.removeItem("linkedinurl");
        localStorage.removeItem("owndomain");
        localStorage.removeItem("ChangepayMode");
        localStorage.removeItem("IdChangingMode");
        localStorage.removeItem("user_name");
        localStorage.removeItem("refreshCount");
        localStorage.removeItem("publishingCampId");
        localStorage.removeItem("Authorurl");
        localStorage.removeItem("Authorname");
        localStorage.removeItem("authorDefaultCheck");
        localStorage.removeItem("appsumo_coupon_code");
        localStorage.removeItem("podcastUrl");
        localStorage.removeItem("AlertMessage");
        localStorage.removeItem("CreatingfromLanding");
        localStorage.removeItem("UrlfromLanding");
        localStorage.removeItem("signedup");
        localStorage.removeItem("uploadedvideo");
        localStorage.removeItem("uploadedVideoName");
        localStorage.removeItem("uploadStatus");
        localStorage.removeItem("editedposthashtags");
        localStorage.removeItem("editedpostblogsummary");
        localStorage.removeItem("editedpostblogtitle");
        localStorage.removeItem("editedposturl");
        localStorage.removeItem("user_email");
        localStorage.removeItem("YoutubeUrlfromLanding");
        localStorage.removeItem("FirstLogin");
        localStorage.removeItem("DirectSignup");
        localStorage.removeItem("FromIndexPage");
        localStorage.removeItem("activeItem");
        localStorage.removeItem("UpdateduserImage");
        localStorage.removeItem("FromEditBlog");
        localStorage.removeItem("ErrorAlert");
        localStorage.removeItem("FromSignIn");
        removeCookie("user_email");
        localStorage.clear();
        if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
          navigate("/Anycode_landing");
        else redirectAfterLogout(); //"https://ocesha.ai";
      } else if (itemName == "images") {
        setActiveItem("images");
      } else if (itemName == "createcourse") {
        setActiveItem("createcourse");
      } else if (itemName === "course") {
        setActiveItem("course");
      } else if (itemName === "profile" || itemName === "authority") {
        navigate(location.pathname, {
          replace: true,
          state: { creator: userDets },
        });

      } else if (itemName === "digital") {
        setActiveItem("digital");
      } else if (itemName === "createcourse3") {
        setActiveItem("createcourse3");
      }
    }
  };

  useEffect(() => {
    // Only guard the Back button while the user is actually on the Digital Twin page with something uploading.
    if (!(isDigitalTwinUploading && activeItem === "digital")) return;

    // Push one extra history entry so the first Back press lands on this
    // same page instead of really leaving — that's what we intercept below.
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Undo this back navigation for now (push forward again) and ask.
      window.history.pushState(null, "", window.location.href);
      setPendingMenuItem("__browser_back__");
      setLeaveUploadConfirmOpen(true);
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [isDigitalTwinUploading, activeItem]);

  const handleCancelLeaveUpload = () => {
    setLeaveUploadConfirmOpen(false);
    setPendingMenuItem(null);
  };

  const showGBALogo =
    localStorage.getItem("partner_name") /* === "GPA" */ ||
    userDets?.partner /* === "GPA" */;

  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

  useEffect(() => {
    if (role != "student" && (localStorage.getItem("DirectSignup") === "true"
      || localStorage.getItem("ocesha_welcome_seen") == "1"
      || localStorage.getItem("CreatingfromLanding") == "true" || localStorage.getItem("FirstLogin") == "True")) {
      setHelperVideoSrc(latestDashBoardVideo);
      setHelperPopup(true);

      //alert(localStorage.getItem("DirectSignup")+"--"+localStorage.getItem("ocesha_welcome_seen")+"--"+localStorage.getItem("CreatingfromLanding")+"--"+localStorage.getItem("FirstLogin"));

      localStorage.removeItem("DirectSignup");
      localStorage.removeItem("FirstLogin");
      localStorage.removeItem("CreatingfromLanding");
    }
  }, []);

  const getPartnerDetails = async () => {
    try {

      const response = await axios.get(
        `${apiUrl}/api/users/partners/details`,
        {
          params: {
            partner_name: showGBALogo/* "GPA" */,
          },
        }
      );

      if (
        response.data?.status === "success" &&
        response.data?.data
      ) {
        const data = response.data.data;
        setGBAUserLogo(data.logo_url);
      }
    } catch (err) {
      console.log("Partner details not found", err);
    }
  };

  useEffect(() => {
    if (showGBALogo) {
      getPartnerDetails();
    }
  }, []);

  // ── Lumi: load the Ocesha AI Concierge widget on mount ──
  // Same as adding:
  // <script src="https://ocesha.com/ci/v1/loader.js" data-ocesha-ci-key="ci_pk_..." async></script>
  // The loader renders the "Hi, I'm Lumi" card fixed at the bottom-right.
  useEffect(() => {
    const alreadyLoaded =
      (window as any).__oceshaCiLoaded?.[OCESHA_CI_KEY] ||
      document.querySelector(`script[data-ocesha-ci-key="${OCESHA_CI_KEY}"]`);
    if (alreadyLoaded) return;

    const script = document.createElement("script");
    script.src = OCESHA_CI_SRC;
    script.async = true;
    script.setAttribute("data-ocesha-ci-key", OCESHA_CI_KEY);
    document.body.appendChild(script);

    // Remove Lumi when leaving the dashboard so it doesn't stay on other pages.
    return () => {
      document
        .querySelectorAll('[data-ocesha-ci="floating"]')
        .forEach((el) => el.remove());
      script.remove();
      if ((window as any).__oceshaCiLoaded) {
        delete (window as any).__oceshaCiLoaded[OCESHA_CI_KEY];
      }
    };
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (activeItem === "createblog") {
      navigate("/codegenie/generated-blogs");
    } else if (activeItem == "createcontent") {
      navigate("/codegenie/generated-blogs");
    }
  }, [activeItem, navigate, params]);

  const FromSignIn = localStorage.getItem("FromSignIn");

  // ─────────────────────────────────────────────────────────────
  // NEW SIDEBAR RENDER (used by both desktop and mobile drawer)
  // ─────────────────────────────────────────────────────────────
  const isStudent = userDets?.role === "student";
  const isLifetime =
    planDetails?.plan_name === "Life Time - STARTER" ||
    planDetails?.plan_name === "Life Time - CREATOR" ||
    planDetails?.plan_name === "Life Time - PROFESSIONAL" ||
    planDetails?.plan_name === "Life Time - ENTERPRISE";

  const renderSidebar = () => (
    <>
      {/* Logo + Help video */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2.5, pt: 2.5, pb: 2 }}>
        <Box
          component="a"
          href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}
          sx={{ display: "inline-flex", alignItems: "center", flex: 1, minWidth: 0 }}
        >
          <Box
            component="img"
            src={ocesha_logo}
            alt="Ocesha"
            sx={{ height: 60, width: "auto", maxWidth: "100%", objectFit: "contain", display: "block" }}
          />
        </Box>
        <Tooltip title="Click here for help video...">
          <Box
            component="img"
            src={youtubeIco1}
            alt="Help video"
            onClick={() => {
              //setHelperVideoSrc("/images/Overview_new.mp4?v3");
              // setHelperVideoSrc("https://www.youtube.com/embed/1D80JhbO-UM");
              setHelperVideoSrc(latestDashBoardVideo);
              setHelperPopup(true);
            }}
            sx={{ height: 48, width: "auto", cursor: "pointer", flexShrink: 0 }}
          />
        </Tooltip>
      </Stack>

      {/* AI Digital Twin card — replaced by Lumi (floating widget loaded via script, see the Lumi useEffect above)
      <Box sx={{
        mx: 2, mb: 2, p: 1.5, borderRadius: "12px",
        background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
        border: "1px solid rgba(255,255,255,0.06)",
        cursor: "pointer",
      }}
        onClick={() => { setOpenAIConcierge(true); setIsMenuOpen(false); }}
      >
        <Typography sx={{
          fontSize: 10, color: "rgba(255,255,255,0.45)",
          letterSpacing: 1, fontWeight: 600, mb: 1,
        }}>
          AI Concierge
        </Typography>
        <Stack direction="row" spacing={1.2} alignItems="center" mb={1.5}>
          <Box component="img" src={userDets?.profile_image || RohanImg} sx={{
            width: 36, height: 36, borderRadius: "50%", objectFit: "cover",
          }} />
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
              AI Concierge Online
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E" }} />
              <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>
                Ask AI Concierge
              </Typography>
            </Stack>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center"
          sx={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: "8px", px: 1.2, py: 0.6,
            cursor: "pointer",
            "&:hover": { background: "rgba(255,255,255,0.07)" },
          }}>
          <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", flex: 1 }}>
            Ask My AI Twin
          </Typography>
          <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.5)" }} />
        </Stack>
      </Box>
      */}

      {/* Main nav */}
      <Stack spacing={0.4} sx={{ px: 1.5 }}>
        {/* {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("dashboard"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              background: activeItem === "dashboard"
                ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
              color: activeItem === "dashboard" ? "#fff" : "rgba(255,255,255,0.7)",
              "&:hover": { background: activeItem === "dashboard" ? undefined : "rgba(255,255,255,0.04)" },
            }}>
            <DashboardIco />
            <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "dashboard" ? 600 : 500 }}>
              Dashboard
            </Typography>
          </Stack>
        )} */}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("authority"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              background: activeItem === "authority"
                ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
              color: activeItem === "authority" ? "#fff" : "rgba(255,255,255,0.7)",
              "&:hover": { background: activeItem === "authority" ? undefined : "rgba(255,255,255,0.04)" },
            }}>
            <InsightsIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "authority" ? 600 : 500 }}>
              Dashboard
            </Typography>
          </Stack>
        )}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => {
              // window.open() carries no React Router state, so we can't rely on
              // the `location.state.creator` path InstructorProfilePage normally
              // uses. It also supports loading itself from a `mentor_id` query
              // param (self-fetches the profile via API) — that's the path a
              // fresh tab needs.
              const mentorId = userDets?._id || userDets?.mentor_id || "";
              const profileIdentifier =
                userDets?.profile_id ||
                userDets?.mentor_id ||
                userDets?._id ||
                userDets?.userid;
              const url = `${window.location.origin}/profile/${encodeURIComponent(profileIdentifier)}`;
              window.open(url, "_blank", "noopener,noreferrer");
              setIsMenuOpen(false);
            }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "profile" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "profile" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <PersonIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Profile Page</Typography>
          </Stack>
        )}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("analytics"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "analytics" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "analytics" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <EqualizerIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Analytics</Typography>
          </Stack>
        )}

        {((localStorage.getItem('partner_name') /* === 'GPA' */ && localStorage.getItem('partner_type') === 'Associate admin') || (userDets?.partner /* === 'GPA' */ && userDets?.partner_type === 'Associate admin')) && (<Stack direction="row" spacing={1.2} alignItems="center"
          onClick={() => { handleItemClick("associate_admin"); setIsMenuOpen(false); }}
          sx={{
            cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
            background: activeItem === "associate_admin"
              ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
            color: activeItem === "associate_admin" ? "#fff" : "rgba(255,255,255,0.7)",
            "&:hover": { background: activeItem === "associate_admin" ? undefined : "rgba(255,255,255,0.04)" },
          }}>
          <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "associate_admin" ? 600 : 500 }}>
            {/* Associate Admin */}Partner Admin
          </Typography>
        </Stack>)}

        <Stack direction="row" spacing={1.2} alignItems="center"
          onClick={() => { handleItemClick("course"); setIsMenuOpen(false); }}
          sx={{
            cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
            background: activeItem === "course"
              ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
            color: activeItem === "course" ? "#fff" : "rgba(255,255,255,0.7)",
            "&:hover": { background: activeItem === "course" ? undefined : "rgba(255,255,255,0.04)" },
          }}>
          <PlayCircleFilledWhiteOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "course" ? 600 : 500 }}>
            My Courses
          </Typography>
        </Stack>

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("learners"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              background: activeItem === "learners"
                ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
              color: activeItem === "learners" ? "#fff" : "rgba(255,255,255,0.7)",
              "&:hover": { background: activeItem === "learners" ? undefined : "rgba(255,255,255,0.04)" },
            }}>
            <GroupsOutlinedIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: activeItem === "learners" ? 600 : 500 }}>
              My Learners
            </Typography>
          </Stack>
        )}

        {/* Content Library — expandable */}
        {!isStudent && (
          <Box>
            <Stack direction="row" spacing={1.2} alignItems="center"
              onClick={() => setIsContentOpen(!isContentOpen)}
              sx={{
                cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                color: "rgba(255,255,255,0.7)",
                "&:hover": { background: "rgba(255,255,255,0.04)" },
              }}>
              <FolderIcon sx={{ fontSize: 18 }} />
              <Typography sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
                Content Library
              </Typography>
              {isContentOpen
                ? <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                : <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
            </Stack>

            {isContentOpen && (
              <Stack spacing={0.3} sx={{ ml: 3, mt: 0.3 }}>
                {[
                  { id: "blogs", label: "Blogs", Icon: BlogsIco },
                  { id: "episodes", label: "Episodes", Icon: EpisodeIco },
                  { id: "clips", label: "Clips", Icon: ClipIco },
                  { id: "images", label: "Images", Icon: ImagesIco },
                  { id: "socailpost", label: "Social Post", Icon: CampaignIcon },
                ].map((item) => {
                  const active = activeItem === item.id;
                  const Ico = item.Icon as any;
                  return (
                    <Stack key={item.id} direction="row" spacing={1} alignItems="center"
                      onClick={() => { handleItemClick(item.id); setIsMenuOpen(false); }}
                      sx={{
                        cursor: "pointer", px: 1.2, py: 0.7, borderRadius: "7px",
                        color: active ? "#4BA5EB" : "rgba(255,255,255,0.6)",
                        background: active ? "rgba(75,165,235,0.08)" : "transparent",
                        "&:hover": { background: "rgba(255,255,255,0.03)" },
                      }}>
                      <Ico />
                      <Typography sx={{ fontSize: 12.5 }}>{item.label}</Typography>
                    </Stack>
                  );
                })}
              </Stack>
            )}
          </Box>
        )}

        {/* My Digital Twin */}
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("digital"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, mt: 0.4, borderRadius: "8px",
              color: activeItem === "digital" ? "#4BA5EB" : "rgba(255,255,255,0.7)",
              background: activeItem === "digital" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <SmartToyIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>My Digital Twin</Typography>
          </Stack>
        )}
      </Stack>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", my: 2, mx: 2 }} />

      {/* Bottom nav */}
      <Stack spacing={0.4} sx={{ px: 1.5, pb: 2 }}>
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => handleItemClick("upgrade")}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "upgrade" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "upgrade" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <UpgradeIco />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
              {isLifetime ? "Features" : "Upgrade"}
            </Typography>
          </Stack>
        )}



        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("payment"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "payment" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "payment" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <BillingIco />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Connect Stripe</Typography>
          </Stack>
        )}

        {(!isStudent && process.env.REACT_APP_SHOPLINE === 'yes') && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("shopline"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "shopline" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "shopline" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <StorefrontOutlinedIcon />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Shopline Products</Typography>
          </Stack>
        )}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("message"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "message" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "message" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <Person2Outlined sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Messages &amp; Leads</Typography>
          </Stack>
        )}

        {/* Team menu hidden for now - remove this comment to show it again
        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { setTeamModalOpen(true); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: teamModalOpen ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: teamModalOpen ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <TeamIco />
            <Typography sx={{ fontSize: 13, fontWeight: 500, flex: 1 }}>Team</Typography>
            {!canUseTeam && (
              <Box sx={{
                fontSize: 9.5, fontWeight: 700, px: 0.8, py: 0.2, borderRadius: "4px",
                color: "#fff", background: "linear-gradient(90deg,#8B5CF6,#4BA5EB)",
              }}>
                PRO
              </Box>
            )}
          </Stack>
        )} */}

        {!isStudent && (
          <Stack direction="row" spacing={1.2} alignItems="center"
            onClick={() => { handleItemClick("settings"); setIsMenuOpen(false); }}
            sx={{
              cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
              color: activeItem === "settings" ? "#4BA5EB" : "rgba(255,255,255,0.65)",
              background: activeItem === "settings" ? "rgba(75,165,235,0.08)" : "transparent",
              "&:hover": { background: "rgba(255,255,255,0.04)" },
            }}>
            <SettingsIco />
            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Settings</Typography>
          </Stack>
        )}

      </Stack>
      <Stack
        direction="row"
        spacing={1.2}
        alignItems="center"
        onClick={() => setContactUsOpen(true)}
        sx={{
          cursor: "pointer",
          px: 1.5,
          py: 1,
          borderRadius: "8px",
          color: "rgba(255,255,255,0.65)",
          "&:hover": {
            background: "rgba(255,255,255,0.04)",
          },
        }}
      >
        <HelpIco />
        <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
          Contact Us
        </Typography>
      </Stack>
    </>
  );

  return (
    <>
      <Box sx={{
        display: "flex", minHeight: "100vh", width: "100%",
        background: "#000000", color: "#fff",
        fontFamily: "'Inter', -apple-system, sans-serif",
        overflowX: "hidden", boxSizing: "border-box",
      }}>

        {/* ═══════════════ MOBILE HAMBURGER + DRAWER ═══════════════ */}
        {isMobile && (
          <>
            <IconButton
              onClick={handleMenuToggle}
              sx={{
                position: "fixed", top: 10, left: 10, zIndex: 1100,
                color: "#fff", background: "rgba(0,0,0,0.5)",
                "&:hover": { background: "rgba(0,0,0,0.7)" },
              }}
            >
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>

            {isMenuOpen && (
              <Box sx={{
                position: "fixed", top: 0, left: 0,
                width: "75%", maxWidth: 300, height: "100vh", zIndex: 1050,
                background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)",
                borderRight: "1px solid rgba(255,255,255,0.06)",
                overflowY: "auto",
              }}>
                {renderSidebar()}
              </Box>
            )}
          </>
        )}

        {/* ═══════════════ DESKTOP SIDEBAR (fixed — always full viewport height) ═══════════════ */}
        {!isMobile && (
          <Box sx={{
            width: 260,
            background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)",
            borderRight: "1px solid rgba(255,255,255,0.06)",
            display: "flex", flexDirection: "column",
            position: "fixed", top: 0, left: 0,
            height: "100vh", overflowY: "auto",
            zIndex: 100,
          }}>
            {renderSidebar()}
          </Box>
        )}

        {/* ═══════════════ MAIN CONTENT ═══════════════ */}
        <Box
          sx={{
            flex: 1,
            ml: !isMobile ? "260px" : 0,
            minHeight: "100vh",
            width: !isMobile ? "calc(100% - 260px)" : "100%",
          }}
          onClick={() => setIsMenuOpen(false)}
        >

          {/* TOP HEADER BAR — bell + avatar only (no Back / no Create New) */}
          <Stack
            direction="row"
            alignItems="center"
            // justifyContent="flex-end"
            justifyContent="space-between"
            sx={{
              px: { xs: 2, md: 3 }, py: 1.5,
              borderBottom: "1px solid rgba(255,255,255,0.06)",
              background: "rgba(0,0,0,0.4)",
              position: "sticky", top: 0, zIndex: 10,
              backdropFilter: "blur(10px)",
            }}
          >
            {/* Left Logo */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {(showGBALogo && GBAUserLogo) && (
                <Box
                  component="img"
                  src={GBAUserLogo}
                  alt="GBA Logo"
                  sx={{
                    /* height: 36, */
                    height: '100px',
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              {/* {userDets?.role === "user" && (
                <Tooltip
                  title={
                    Number(userDets?.total_credits) === -1
                      ? ""
                      : canAddOnCredits
                      ? "Add more credits"
                      : "Available on Growth & Pro plans"
                  }
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={0.5}
                    onClick={() => {
                      if (Number(userDets?.total_credits) !== -1 && canAddOnCredits) {
                        setAddCreditsOpen(true);
                      }
                    }}
                    sx={{
                      px: 1.4,
                      py: 0.6,
                      pr: Number(userDets?.total_credits) === -1 || !canAddOnCredits ? 1.4 : 0.7,
                      borderRadius: "999px",
                      background: "rgba(255,255,255,0.06)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      cursor:
                        Number(userDets?.total_credits) === -1 || !canAddOnCredits
                          ? "default"
                          : "pointer",
                      transition: "all 0.15s ease",
                      "&:hover":
                        Number(userDets?.total_credits) === -1 || !canAddOnCredits
                          ? {}
                          : {
                              background: "rgba(255,255,255,0.1)",
                              borderColor: "rgba(255,255,255,0.18)",
                            },
                    }}
                  >
                    <BoltIcon sx={{ fontSize: 16, color: "#F59E0B" }} />
                   <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
                      {Number(userDets?.total_credits) === -1
                        ? "Unlimited"
                        : Number(userDets?.total_credits ?? 0).toLocaleString()}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)" }}>
                      credits
                    </Typography> 
                    {Number(userDets?.total_credits) !== -1 && canAddOnCredits && (
                      <Box
                        sx={{
                          ml: 0.3,
                          width: 18,
                          height: 18,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "rgba(139,92,246,0.18)",
                        }}
                      >
                        <AddOutlinedIcon sx={{ fontSize: 13, color: "#A78BFA" }} />
                      </Box>
                    )} 
                  </Stack>
                </Tooltip>
              )} */}
              {(process.env.REACT_APP_MULTI_LINGUAL === 'yes') && (<LanguageSwitcher />)}

              <IconButton sx={{ position: "relative", color: "rgba(255,255,255,0.7)" }}>
                <NotificationsNoneOutlinedIcon sx={{ fontSize: 22 }} />
                <Box sx={{
                  position: "absolute", top: 6, right: 6,
                  width: 18, height: 18, borderRadius: "50%",
                  background: "#EF4444", color: "#fff",
                  fontSize: 10, fontWeight: 700,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  0
                </Box>
              </IconButton>

              <Box
                component="img"
                src={userDets?.user_image ? `${userDets.user_image}?v=${imageVersion}` : UserImg}
                onClick={(e: any) => setProfileMenuAnchor(e.currentTarget)}
                sx={{
                  width: 36, height: 36, borderRadius: "50%", objectFit: "cover", objectPosition: "top center",
                  border: "2px solid rgba(255,255,255,0.1)", cursor: "pointer",

                }}
              />

              <Menu
                anchorEl={profileMenuAnchor}
                open={isProfileMenuOpen}
                onClose={() => setProfileMenuAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    background: "#0F1117",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: "10px",
                    minWidth: 180,
                    color: "#fff",
                    "& .MuiMenuItem-root": {
                      fontSize: 13,
                      py: 1, px: 1.5,
                      "&:hover": { background: "rgba(255,255,255,0.06)" },
                    },
                    "& .MuiListItemIcon-root": {
                      minWidth: 32, color: "rgba(255,255,255,0.65)",
                    },
                  },
                }}
              >
                <Box sx={{ px: 1.5, py: 1.2, borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
                    {userDets?.first_name || "User"} {userDets?.last_name || ""}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: 0.2 }}>
                    {userDets?.email || useremail}
                  </Typography>
                </Box>

                <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("profile"); }}>
                  <ListItemIcon><PersonIcon sx={{ fontSize: 18 }} /></ListItemIcon>
                  Profile
                </MenuItem>
                <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("settings"); }}>
                  <ListItemIcon><SettingsIco /></ListItemIcon>
                  Settings
                </MenuItem>
                <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("billing"); }}>
                  <ListItemIcon><BillingIco /></ListItemIcon>
                  Billing
                </MenuItem>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />
                <MenuItem
                  onClick={() => { setProfileMenuAnchor(null); handleItemClick("logout"); }}
                  sx={{ color: "#F87171 !important" }}
                >
                  <ListItemIcon sx={{ "& svg": { color: "#F87171" } }}>
                    <LogoutIco />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Stack>
          </Stack>

          {/* PAGE BODY — exact same switch as the original */}
          <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 2.5 } }}>
            {activeItem === "blogs" ? (
              <Blogs_Section />
            ) : activeItem === "dashboard" ? (
              <MyDashboard />
            ) : activeItem === "images" ? (
              <Image_listing />
            ) : activeItem === "settings" ? (
              <Usersetting />
            ) : activeItem === "billing" ? (
              <Billing />
            ) : activeItem === "episodes" ? (
              <Episodes_Section />
            ) : activeItem === "clips" ? (
              <Clips_Section />
            ) : activeItem === "payment" ? (
              <AddPayment />
            ) : activeItem === "digital" ? (
              <DigitalTwinScreen onUploadStatusChange={setIsDigitalTwinUploading} cancelUploadRef={uploadAbortRef} />
            ) : activeItem === "profile" ? (
              <InstructorProfilePage />
            ) : activeItem === "course" ? (
              <ListingCourses />
            ) : activeItem === "learners" ? (
              <CourseEnrollments mode="instructor" />
            ) : activeItem === "upgrade" ? (
              <PricingPage />
            ) : activeItem === "authority" ? (
              <AuthorityEngine />
            ) : activeItem === "createcourse" ? (
              <New_Course_2_1 />
            ) : activeItem === "marketing" ? (
              <Marketing />
            ) : activeItem === "socailpost" ? (
              <SocialPost />
            ) : activeItem === "message" ? (
              <MessagesAndFollowers />
            ) : activeItem === "createcourse3" ? (
              <New_Course_3 />
            ) : activeItem === "createblog" ? (
              <New_Campaign />
            ) : activeItem === "createcontent" ? (
              <New_Podcast />
            ) : activeItem === "analytics" ? (
              <AnalyticsDashboard />
            ) : activeItem === "associate_admin" ? (
              <GBA_Registration />
            ) : activeItem === "shopline" ? (
              <ConnectShopline />
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Box>

      {/* ── MODALS — unchanged from original ── */}
      <Modal
        open={helperPopup}
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%", left: "50%",
            display: "flex", flexDirection: "column", alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "70%",
            bgcolor: "#0F1117",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            pt: 2, px: 4, pb: 3,
            borderRadius: "15px", padding: "3%",
          }}
        >
          <iframe
            width="100%" height="500" src={helpervideosrc}
            title="Help Video" frameBorder="0"
            allow="autoplay; encrypted-media" allowFullScreen
          />
          <Stack flexDirection="row">
            <Button
              onClick={() => setHelperPopup(false)}
              variant="contained"
              sx={{
                mr: 2, marginTop: "15%",
                background: "linear-gradient(90deg, #0168B5, #4BA5EB)",
                borderRadius: "8px", textTransform: "none", fontWeight: 600,
              }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={upgradeModal}
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "60%", left: "50%",
            display: "flex", flexDirection: "column", alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "55%",
            bgcolor: "#0F1117",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            pt: 2, px: 4, pb: 3,
            borderRadius: "15px", padding: "3%",
          }}
        >
          <Typography style={{ textAlign: "center", color: "#fff" }}>
            <InfoIcon sx={{ color: "#ffcc00" }} />
            <br />
            This feature is not included in your plan. Please upgrade to have
            access to this feature.
          </Typography>

          <Stack flexDirection="row" sx={{ display: "flex", gap: "10px", marginTop: "1%" }}>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(90deg, #0168B5, #4BA5EB)",
                borderRadius: "8px", textTransform: "none", fontWeight: 600,
              }}
              onClick={() => {
                const value = {
                  _id: "", product_name: "CodeGenie",
                  product_module: genieSelector.module ? genieSelector.module : "",
                  userid: "", productid: "",
                };
                getProduct(value);
                localStorage.setItem("fromUpgrade", "true");
                navigate("/pricing", {
                  state: {
                    campIdFromUpgrade: selectedCampaign,
                    from_page: "pricing",
                    fromNonSubscribed: "true",
                  },
                });
              }}
            >
              {"Upgrade"}
            </Button>

            <Button
              onClick={() => setUpgradeModal(false)}
              variant="outlined"
              sx={{
                borderColor: "rgba(255,255,255,0.2)", color: "#aaa",
                borderRadius: "8px", textTransform: "none", fontWeight: 600,
              }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={addCreditsOpen && canAddOnCredits}
        onClose={() => !purchasingCredits && setAddCreditsOpen(false)}
        aria-labelledby="add-credits-modal-title"
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0,0,0,0.75)",
            backdropFilter: "blur(4px)",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "94%" : 640,
            maxHeight: "88vh",
            overflowY: "auto",
            bgcolor: "#0F1117",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.55)",
            borderRadius: "16px",
            p: { xs: 2.5, md: 3.5 },
          }}
        >
          {/* Header */}
          <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ mb: 2.5 }}>
            <Box>
              <Typography id="add-credits-modal-title" sx={{ color: "#fff", fontSize: 19, fontWeight: 700 }}>
                Add credits
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: 13, mt: 0.4 }}>
                Top up your balance any time — credits never expire.
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => !purchasingCredits && setAddCreditsOpen(false)}
              sx={{ color: "rgba(255,255,255,0.5)", mt: -0.5, mr: -0.5 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>

          {/* Current balance */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.8}
            sx={{
              display: "inline-flex",
              px: 1.4,
              py: 0.6,
              mb: 2.5,
              borderRadius: "999px",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <BoltIcon sx={{ fontSize: 15, color: "#F59E0B" }} />
            <Typography sx={{ fontSize: 12.5, color: "rgba(255,255,255,0.65)" }}>
              Current balance:{" "}
              <Typography component="span" sx={{ fontSize: 12.5, fontWeight: 700, color: "#fff" }}>
                {Number(userDets?.total_credits ?? 0).toLocaleString()}
              </Typography>
            </Typography>
          </Stack>

          {/* Amount picker */}
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.55)", mb: 1 }}>
            Choose an amount
          </Typography>

          <Box
            sx={{
              p: { xs: 2.5, md: 3 },
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.08)",
              background:
                "linear-gradient(180deg, rgba(139,92,246,0.08), rgba(139,92,246,0.015))",
            }}
          >
            {/* Big editable amount */}
            <Stack direction="row" justifyContent="center" sx={{ mb: 1 }}>
              <TextField
                variant="standard"
                value={addOnAmountInput}
                onChange={(e) => {
                  const raw = e.target.value.replace(/[^0-9]/g, "");
                  setAddOnAmountInput(raw);
                  if (raw !== "") setAddOnAmount(clampAddOnAmount(Number(raw)));
                }}
                onBlur={() => {
                  const clamped = clampAddOnAmount(Number(addOnAmountInput) || MIN_ADDON_AMOUNT);
                  setAddOnAmount(clamped);
                  setAddOnAmountInput(String(clamped));
                }}
                inputProps={{
                  inputMode: "numeric",
                  style: {
                    textAlign: "center",
                    fontSize: 40,
                    fontWeight: 800,
                    color: "#fff",
                    width: `${Math.max(2, addOnAmountInput.length)}ch`,
                  },
                }}
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start" sx={{ mr: 0 }}>
                      <Typography sx={{ fontSize: 32, fontWeight: 700, color: "rgba(255,255,255,0.55)" }}>
                        $
                      </Typography>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInput-root": { "&:before, &:after": { display: "none" } },
                }}
              />
            </Stack>
            <Typography sx={{ textAlign: "center", fontSize: 11.5, color: "rgba(255,255,255,0.4)", mb: 2.5 }}>
              Min ${MIN_ADDON_AMOUNT} · Max ${MAX_ADDON_AMOUNT}
            </Typography>

            {/* Slider */}
            <Slider
              value={addOnAmount}
              min={MIN_ADDON_AMOUNT}
              max={MAX_ADDON_AMOUNT}
              onChange={(_e, value) => {
                const next = Array.isArray(value) ? value[0] : value;
                setAddOnAmount(next);
                setAddOnAmountInput(String(next));
              }}
              sx={{
                color: "#8B5CF6",
                height: 6,
                "& .MuiSlider-thumb": {
                  width: 18,
                  height: 18,
                  backgroundColor: "#fff",
                  border: "3px solid #8B5CF6",
                  boxShadow: "0 0 0 4px rgba(139,92,246,0.18)",
                  "&:hover, &.Mui-focusVisible": {
                    boxShadow: "0 0 0 6px rgba(139,92,246,0.22)",
                  },
                },
                "& .MuiSlider-rail": { opacity: 1, backgroundColor: "rgba(255,255,255,0.1)" },
              }}
            />
            <Stack direction="row" justifyContent="space-between" sx={{ mt: -0.5 }}>
              <Typography sx={{ fontSize: 10.5, color: "rgba(255,255,255,0.35)" }}>
                ${MIN_ADDON_AMOUNT}
              </Typography>
              <Typography sx={{ fontSize: 10.5, color: "rgba(255,255,255,0.35)" }}>
                ${MAX_ADDON_AMOUNT}
              </Typography>
            </Stack>

            {/* Quick amounts */}
            <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 2.5 }}>
              {ADDON_QUICK_AMOUNTS.map((amt) => {
                const isActive = addOnAmount === amt;
                return (
                  <Box
                    key={amt}
                    onClick={() => {
                      setAddOnAmount(amt);
                      setAddOnAmountInput(String(amt));
                    }}
                    sx={{
                      cursor: "pointer",
                      px: 1.6,
                      py: 0.6,
                      borderRadius: "999px",
                      fontSize: 12.5,
                      fontWeight: 600,
                      color: isActive ? "#fff" : "rgba(255,255,255,0.6)",
                      border: isActive ? "1px solid #8B5CF6" : "1px solid rgba(255,255,255,0.1)",
                      background: isActive ? "rgba(139,92,246,0.25)" : "rgba(255,255,255,0.04)",
                      transition: "all 0.15s ease",
                      "&:hover": {
                        borderColor: "#8B5CF6",
                        background: "rgba(139,92,246,0.18)",
                      },
                    }}
                  >
                    ${amt}
                  </Box>
                );
              })}
            </Stack>
          </Box>

          {/* Footer / summary */}
          <Divider sx={{ my: 2.5, borderColor: "rgba(255,255,255,0.08)" }} />

          <Stack
            direction={isMobile ? "column" : "row"}
            alignItems={isMobile ? "stretch" : "center"}
            justifyContent="space-between"
            spacing={1.5}
          >
            <Box>
              <Typography sx={{ fontSize: 11.5, color: "rgba(255,255,255,0.45)" }}>
                You'll be charged
              </Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>
                ${addOnAmount}
              </Typography>
            </Box>

            <Stack direction="row" spacing={1.2}>
              <Button
                onClick={() => setAddCreditsOpen(false)}
                disabled={purchasingCredits}
                variant="outlined"
                sx={{
                  borderColor: "rgba(255,255,255,0.2)",
                  color: "#aaa",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>
              <LoadingButton
                onClick={handlePurchaseCredits}
                loading={purchasingCredits}
                disabled={purchasingCredits || addOnAmountInput === "" || addOnAmount < MIN_ADDON_AMOUNT}
                variant="contained"
                sx={{
                  background: "linear-gradient(90deg, #0168B5, #4BA5EB)",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  px: 2.5,
                  "&.Mui-disabled": { opacity: 0.6, color: "#fff" },
                }}
              >
                Purchase
              </LoadingButton>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <AIConciergePopup
        open={openAIConcierge}
        onClose={() => setOpenAIConcierge(false)}
        courseid={currentCourseId}
      />

      <TeamMembersModal
        open={teamModalOpen}
        onClose={() => setTeamModalOpen(false)}
        isEligible={canUseTeam}
        onUpgrade={() => handleItemClick("upgrade")}
        owner={{
          name: `${userDets?.first_name || ""} ${userDets?.last_name || ""}`.trim(),
          email: useremail,
          username: userDets?.username,
          avatar_url: userDets?.user_image,
        }}
      />

      <ContactUsModal
        open={contactUsOpen}
        onClose={() => setContactUsOpen(false)}
        userDets={userDets}
      />

      <Dialog
        open={leaveUploadConfirmOpen}
        onClose={handleCancelLeaveUpload}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            background: "#12151c",
            border: "1px solid rgba(255,255,255,0.08)",
            maxWidth: 420,
          },
        }}
      >
        <DialogTitle sx={{ color: "#f8fafc", fontWeight: 600, fontSize: "18px" }}>
          Upload still in progress
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "14px", lineHeight: 1.7 }}>
            An upload is still in progress. If you leave this page now, the upload will stop and you'll need to upload it again.
            <br />
            <br />
            Do you want to leave anyway?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button
            onClick={handleCancelLeaveUpload}
            fullWidth
            sx={{
              color: "#fff",
              borderRadius: "12px",
              py: 1.2,
              textTransform: "none",
              fontWeight: 500,
              border: "1px solid #4BA5EB",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmLeaveUpload}
            fullWidth
            sx={{
              background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
              color: "#fff",
              borderRadius: "12px",
              py: 1.2,
              textTransform: "none",
              fontWeight: 500,
              "&:hover": {
                background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
                opacity: 0.88,
              },
            }}
          >
            Leave anyway
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default Ocesha_new_design;
